/* lua.js generated code 0.3.1 */
 // RandomFactory = class()
// local kCheckModifyInterval = 100
// function RandomFactory:create()
// 	local randomFactory = RandomFactory.new()
// 	randomFactory:init()
// 	return randomFactory
// end
// function RandomFactory:init()
// 	self.CCPObject = HERandomObject()
// 	self.randomIndex = 0
// 	self.checkModifyInterval = kCheckModifyInterval
// 	self.hasModifyAct = false
// end
// function RandomFactory:rand(a,b)
// 	local r = 0 
// 	if self.CCPObject then
// 		if a and b then
// 			-- self.randomIndex = self.randomIndex + 1
// 			r = self.CCPObject:rand(a,b)
// 			-- self:ModifyCheck()
// 		else
// 			-- self.randomIndex = self.randomIndex + 1
// 			r = self.CCPObject:rand()
// 		end
// 	end
// 	return r
// end
// function RandomFactory:ModifyCheck()
// 	if self.hasModifyAct then return end
// 	self.checkModifyInterval = self.checkModifyInterval - 1
// 	if self.checkModifyInterval <= 0 then
// 		self.checkModifyInterval = kCheckModifyInterval
// 		local r = self.CCPObject:rand(4,9)
// 		if r < 4 or r > 9 then self.hasModifyAct = true end
// 	end
// end
// function RandomFactory:randSeed(seed)
// 	if self.CCPObject and seed then
// 		self.randomIndex = 0
// 		return self.CCPObject:randSeed(seed)
// 	end
// 	return nil
// end
RandomFactory = xClass("RandomFactory")
//let bit = require("bit")
RandomFactory.create = function () {
    let self = this
    let randObj = RandomFactory.new()
    randObj.init()
    return randObj
}
RandomFactory.prototype.init = function () {
    let self = this
    self.holdrand = 0
}
function convertNumberToInt32(num) {
    if (num > 4294967295 || num < -2147483648) {
        num = bit.band(num, 0xffffffff)
    }
    if (num > 2147483648) {
        num = num - 4294967296
    }
    return num
}
RandomFactory.prototype._rand = function () {
    let self = this
    self.holdrand = convertNumberToInt32(self.holdrand * 214013 + 2531011)
    // WARN: maybe multi result
    return bit.band(bit.rshift(self.holdrand, 16), 0x7fff)
}
RandomFactory.prototype.rand = function (a, b) {
    let self = this
    if (a > b) {
        ;[a, b] = [b, a]
    }
    return self._rand() % (b - a + 1) + a
}
RandomFactory.prototype.randSeed = function (seed) {
    let self = this
    if (seed) {
        self.holdrand = seed
    }
    return self.holdrand
}
RandomFactory.prototype.getCurrHoldrand = function () {
    let self = this
    return self.holdrand
}
